import { useNavigate } from "react-router";
import { useDeleteSetup } from "../hooks/useSetups";
import Button from "./Button";
import Dialog from "./Dialog";

interface Props {
  setupId: string;
  open: boolean;
  onClose: () => void;
}

const DeleteSetupDialog = ({ setupId, open, onClose }: Props) => {
  const navigate = useNavigate();
  const mutation = useDeleteSetup();

  return (
    <Dialog
      open={open}
      size="small"
      onClose={() => {
        mutation.reset();
        onClose();
      }}
    >
      <Dialog.Title>Delete setup?</Dialog.Title>
      <Dialog.Content>
        The setup will be deleted immediately. This action cannot be undone.
      </Dialog.Content>
      <Dialog.Footer>
        <Button
          type="accent_secondary"
          buttonProps={{
            onClick: onClose,
          }}
        >
          Cancel
        </Button>
        <Button
          isLoading={mutation.isPending}
          type="accent"
          buttonProps={{
            type: "submit",
            disabled: mutation.isPending,
            onClick: () => {
              mutation.mutate(setupId, {
                onSuccess: () => {
                  onClose();
                  navigate("/");
                },
              });
            },
          }}
        >
          Delete
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export default DeleteSetupDialog;
